import React from "react";
import "./NavBar.css";
import { AiOutlineHome } from "react-icons/ai";
import { MdOutlineContactPhone } from "react-icons/md";
import { GoProjectSymlink } from "react-icons/go";
import { BsInfoSquare } from "react-icons/bs";
import { TbDeviceDesktopCode } from "react-icons/tb";

function NavBar() {
  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <header className="header">
      <div className="container">
        <a href="#" onClick={handleScrollToTop} className="logo">
          Mohamed
        </a>
        <ul>
          <li>
            <a href="#">Home</a>
          </li>
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#projects">Projects</a>
          </li>
          <li>
            <a href="#about"> About</a>
          </li>
          <li>
            <a href="#contact"> Contact Me</a>
          </li>
        </ul>
      </div>
      <div className="menu">
        <ul>
          <li>
            <a href="#">
              <AiOutlineHome />
            </a>
          </li>
          <li>
            <a href="#services">
              <TbDeviceDesktopCode />
            </a>
          </li>
          <li>
            <a href="#projects">
              <GoProjectSymlink />
            </a>
          </li>
          <li>
            <a href="#about">
              <BsInfoSquare />
            </a>
          </li>
          <li>
            <a href="#contact">
              <MdOutlineContactPhone />
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default NavBar;
